;
define("root/Assets/Templates/Html/schnitzelface/Js/schnitzelface", function(){});

